<template>
  <div class="form-check-inline form-switch">
    <input
      :id="id"
      type="checkbox"
      class="form-check-input"
      :disabled="disabled"
      :checked="checked"
      :true-value="trueValue"
      :false-value="falseValue"
      :value="modelValue"
      v-model="localCheckboxValue"
    />
    <label class="form-check-label" :for="id">
      {{ label }}
      <span v-if="sublabel" class="small gray">{{ sublabel }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "Switch",
  emits: ["update:modelValue"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "option",
    },
    trueValue: {
      type: String,
      default: "on",
    },
    falseValue: {
      type: String,
      default: "off",
    },
    sublabel: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: this.randomString(),
    };
  },
  computed: {
    localCheckboxValue: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
